import * as firebase from 'firebase';
import firestore from 'firebase/firestore'

// const settings = {timestampsInSnapshots: true};

// const config = {
//   apiKey: "AIzaSyAb_42dlRejmRzDNRSlkJ5HCIUdyGUGfS4",
//   authDomain: "sofhr.exprogramacion",
//   databaseURL: "YOUR_DATABASE_URL",
//   projectId: "YOUR_PROJECT_ID",
//   storageBucket: "YOUR_STORAGE_BUCKET"
// };
// firebase.initializeApp(config);

// Initialize Firebase
var config = {
    apiKey: "AIzaSyAb_42dlRejmRzDNRSlkJ5HCIUdyGUGfS4",
    authDomain: "sofhr-70723.firebaseapp.com",
    databaseURL: "https://sofhr-70723.firebaseio.com",
    projectId: "sofhr-70723",
    storageBucket: "sofhr-70723.appspot.com",
    messagingSenderId: "562560140769"
  };
  firebase.initializeApp(config);

// firebase.firestore().settings(settings);

export default firebase;